import { API_URL } from "../config/config";
import { getRequest, postRequest } from "../utils/axiosUtils";

export const fetchEmailsList = async (setData) => {
    const res = await getRequest({
        url: `${API_URL}/admin/email/all`,
    });
    if(!res) return

    if (res.status >= 200 && res.status < 300 && res.data) {
        setData(res?.data?.data);
        return res.data;
    } else {
        throw new Error(`Unexpected response code: ${res.status}`);
    }
};

export const createEmailConfig = async (emailConfigData) => {
    try {
        const res = await postRequest({
            url: `${API_URL}/admin/email/save`,
            data: emailConfigData,
        });

        if (res.status >= 200 && res.status < 300 && res.data) {
            return res.data;
        } else {
            throw new Error(`Unexpected response code: ${res.status}`);
        }
    } catch (err) {
        console.error('Error creating email config:', err);
        throw new Error('Error creating email config');
    }
};